/* global Intercom */
import React from 'react';
import PropTypes from 'prop-types';
import { Icon, Segment } from 'semantic-ui-react';
import appStyles from '../../App/App.scss';
import styleVariables from '../../variables';
import documentStyles from '../Document.scss';
import MobileHeader from '../../App/MobileHeader';
import axios from 'axios';
import Actions from './Actions';
import Title from './Title';
import '../../../lib/stylesheets/SlideDownUpTransition.scss';
import OptionsMenu from '../../App/OptionsMenu';

export default class InvoiceHeader extends React.Component {
  static propTypes = {
    addPayment: PropTypes.func.isRequired,
    toggleSidebar: PropTypes.func,
    sidebarOpen: PropTypes.bool,
    document: PropTypes.object.isRequired,
    relay: PropTypes.object.isRequired,
    router: PropTypes.object.isRequired,
    params: PropTypes.object.isRequired,
    viewer: PropTypes.object,
    windowDimensions: PropTypes.object.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      actionsMenuOpen: false
    };
    this.signOut = this.signOut.bind(this);
    this.getHelp = this.getHelp.bind(this);
    this.toggleActionsMenu = this.toggleActionsMenu.bind(this);
  }

  getHelp() {
    /* eslint-disable new-cap */
    if (typeof Intercom !== undefined) Intercom('show');
  }

  signOut() {
    axios.get('/users/sign_out').then(() => {
      window.location = '/';
    });
  }

  toggleActionsMenu() {
    this.setState({ actionsMenuOpen: !this.state.actionsMenuOpen });
  }

  render() {
    const { viewer, router } = this.props;
    return (
      <div>
        {this.props.windowDimensions.width >= styleVariables.tabletBreakpoint &&
          <Segment
            className={[
              appStyles.segmentContainer,
              documentStyles.header
            ].join(' ')}
          >
            <div className='headerNav'>
              <div style={{ flex: 4 }}>
                <div style={{ display: 'flex' }}>
                  {this.props.document.workspaces.edges.length > 0 &&
                    <a
                      className='item'
                      style={{ padding: '0 1.5em 0 0.5em' }}
                      onClick={() => this.props.router.go(-1)}
                    >
                      <i className='chevron left icon' />
                    </a>}
                  <Title
                    node={this.props.document}
                    relay={this.props.relay}
                    canEdit={this.props.document.can_edit}
                  />
                </div>
              </div>
              <div
                style={{
                  flex: 1,
                  textAlign: 'right'
                }}
              >
                <div style={{ display: 'inline-block', marginLeft: '2em' }}>
                  {this.props.viewer && <OptionsMenu viewer={viewer} router={router} />}
                </div>
              </div>
            </div>
          </Segment>
        }
        {this.props.windowDimensions.width < styleVariables.tabletBreakpoint &&
          <div>
            <MobileHeader>
              <div className='menu'>
                {this.props.document.workspaces.edges.length > 0 &&
                  <a
                    className='item'
                    style={{ padding: '0 0.5em' }}
                    onClick={() => this.props.router.go(-1)}
                  >
                    <i className='chevron left icon' />
                  </a>}
                <a
                  className={`${this.props.sidebarOpen ? 'active ' : ''}item`}
                  onClick={this.props.toggleSidebar}
                >
                  <Icon name='sidebar' />
                </a>
              </div>
              <div className='menu right'>
                <a className='item' onClick={this.toggleActionsMenu}>
                  <Icon name='ellipsis vertical' />
                </a>
              </div>
            </MobileHeader>
            {this.state.actionsMenuOpen &&
              <div className={documentStyles.mobileActionMenu} key='actions'>
                <div style={{ padding: '1em' }}>
                  <Title
                    node={this.props.document}
                    relay={this.props.relay}
                    canEdit={this.props.document.can_edit}
                  />
                </div>
                <Actions
                  addPayment={this.props.addPayment}
                  node={this.props.document}
                  params={this.props.params}
                  relay={this.props.relay}
                  router={this.props.router}
                  onClose={this.toggleActionsMenu}
                  windowDimensions={this.props.windowDimensions}
                />
              </div>}
          </div>
        }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./webpack/components/Document/Invoice/Header.js